import React, {ReactElement} from "react"
import {FC, PropsWithChildren} from "react"
import useExpertBioStore from "../../../stores/expertBioStore"

type AuthorProps = {
  authorId: string
  origin: string
}

const Author: FC<PropsWithChildren<AuthorProps>> = (props) => {
  const {authorId, origin, children} = props
  const {setExpertId, setDisplayExpert, setOriginFrom} = useExpertBioStore()

  const authorOnClick = async () => {
    setExpertId(authorId)
    setOriginFrom(origin)
    setDisplayExpert(true)
  }

  return (
    <React.Fragment>
      {React.Children.map(
        children,
        (child) =>
          React.isValidElement(child) &&
          React.cloneElement(child as ReactElement<any>, {
            onClick: authorOnClick,
            style: {...child.props.style, cursor: "pointer"},
          }),
      )}
    </React.Fragment>
  )
}

Author.displayName = "Author"

export default Author
